import React from 'react';
import { Route } from 'react-router-dom';
import OrgStructureItems from '../pages/orgStructureItems/OrgStructureItems';
import OrgStructureItemsArchive from '../pages/orgStructureItems/OrgStructureItemsArchive';
import CreateOrgStructureItem from '../pages/orgStructureItems/CreateOrgStructureItem';
import EditOrgStructureItem from '../pages/orgStructureItems/EditOrgStructureItem';
import PermissionGuard from '../components/global/PermissionGuard';

const orgStructureItemsRoutes = (
    <>
        <Route path="/org-structure-items" element={<PermissionGuard permission="org_structure_items_list"><OrgStructureItems /></PermissionGuard>} />
        <Route path="/org-structure-items/archive" element={<PermissionGuard permission="org_structure_items_archive_list"><OrgStructureItemsArchive /></PermissionGuard>} />
        <Route path="/org-structure-items/create" element={<PermissionGuard permission="org_structure_items_create"><CreateOrgStructureItem /></PermissionGuard>} />
        <Route path="/org-structure-items/:id/edit" element={<PermissionGuard permission="org_structure_items_edit"><EditOrgStructureItem /></PermissionGuard>} />
    </>
);

export default orgStructureItemsRoutes;
